import Head from 'next/head';
import React, { FunctionComponent } from 'react';

import { LOCALES, PRODUCTION_DOMAIN } from '../../../constants';
import { PageSeo } from '../../../types';
import { BasicSeoElements } from '../BasicSEO';
import { useBabelSeo } from '../useBabelSeo';

type HomePageSEOProps = {
  pageSeo: PageSeo;
};

export const HomePageSEO: FunctionComponent<HomePageSEOProps> = ({
  pageSeo,
}: HomePageSEOProps) => {
  const resolveBabelSeo = useBabelSeo();
  const title = resolveBabelSeo('seo.homepage.title', pageSeo?.title);
  const description = resolveBabelSeo(
    'seo.homepage.description',
    pageSeo?.description,
  );

  return (
    <>
      <BasicSeoElements
        title={title}
        description={description}
        imageUrl={pageSeo?.imageUrl}
        robots={pageSeo?.robots}
      />
      <Head>
        {Object.values(LOCALES).map((locale) => (
          <link
            rel="alternate"
            hrefLang={locale}
            href={`https://${PRODUCTION_DOMAIN}/${locale}/`}
            key={locale}
          />
        ))}
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://${PRODUCTION_DOMAIN}/${LOCALES.EN}/`}
        />
      </Head>
    </>
  );
};
